import { Check, Mic, ScanBarcode } from "lucide-react";

export const PLAN_FALLBACK = [
  { key: "chalanito", name: "CHALANITO", tagline: "POS por voz con IA", price_usd: 20, period_label: "mes", ai_enabled: true,
    features: ["Comandos de voz con IA (300/día)", "Chalán responde con voz", "Escáner: pistola Bluetooth y cámara", "Inventario, fiados, mesas y corte", "Catálogo maestro + Open Food Facts", "Recibo digital QR · multi-dispositivo"] },
  { key: "onepay", name: "ONE PAY", tagline: "Punto de venta con escáner · sin IA", price_usd: 25, period_label: "año", ai_enabled: false,
    features: ["Un solo pago al año", "Pistola de escaneo Bluetooth + cámara", "Buscador de productos y botones rápidos", "Inventario, fiados, mesas y corte", "Catálogo maestro + Open Food Facts", "Recibo digital QR · multi-dispositivo"] },
];

export const PlanCard = ({ plan, selected, onSelect, compact, cta }) => {
  const isOne = plan.key === "onepay";
  const Icon = isOne ? ScanBarcode : Mic;
  const accent = isOne ? "#ccff00" : "#ff5a00";
  return (
    <button
      type="button"
      onClick={() => onSelect?.(plan.key)}
      className={`relative text-left rounded-3xl border p-6 md:p-7 transition-colors duration-300 w-full ${
        selected ? "border-white bg-white/[0.06]" : "border-white/10 bg-white/[0.02] hover:border-white/30"
      }`}
      data-testid={`plan-card-${plan.key}`}
      aria-pressed={!!selected}
    >
      {selected && <span className="absolute top-4 right-4 w-6 h-6 rounded-full bg-white text-black flex items-center justify-center"><Check size={14} strokeWidth={3} /></span>}
      <div className="flex items-center gap-2 mb-3">
        <Icon size={16} style={{ color: accent }} />
        <span className="font-mono text-[10px] tracking-[0.3em] uppercase" style={{ color: accent }}>{plan.name}</span>
      </div>
      <div className="flex items-baseline gap-2">
        <span className="font-display text-5xl md:text-6xl tracking-tighter leading-none" data-testid={`plan-price-${plan.key}`}>${plan.price_usd}</span>
        <div className="flex flex-col font-mono text-[10px] uppercase tracking-widest text-white/50 leading-tight">
          <span>USD</span><span>/ {plan.period_label}</span>
        </div>
      </div>
      {plan.price_mxn && <p className="mt-1 font-mono text-[10px] text-white/40 uppercase tracking-widest">≈ ${plan.price_mxn.toFixed(0)} MXN por SPEI</p>}
      <p className="mt-3 text-white/60 text-sm">{plan.tagline}</p>
      {!compact && (
        <ul className="mt-5 space-y-2">
          {plan.features.map((f) => (
            <li key={f} className="flex items-start gap-2 text-sm text-white/80">
              <span className="mt-1 w-3.5 h-3.5 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: accent }}><Check size={9} strokeWidth={3} className="text-black" /></span>
              {f}
            </li>
          ))}
        </ul>
      )}
      {!plan.ai_enabled && (
        <p className="mt-4 text-[11px] font-mono uppercase tracking-widest text-white/40">Sin comandos de voz ni IA · cero costo oculto</p>
      )}
      {cta}
    </button>
  );
};
